export default {
  isImportingDocumentJson: false,
  hasImportedDocumentJson: false,
  importDocumentJsonError: null,
  documentQueue: [],
};
